import { render, staticRenderFns } from "./TutorsView.vue?vue&type=template&id=3fea37c5&"
import script from "./TutorsView.vue?vue&type=script&lang=js&"
export * from "./TutorsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports